<mat-dialog-actions>
  <h2 class="title" >Настройки таблицы</h2>
  <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<form [formGroup]="tableSettings" class="settings" *ngIf="this.tableSettings?.controls">

    <div class="settings-paddings">
        <mat-form-field class="form-field-cs" floatLabel="always" style="margin-right:12px !important; width:300px">
            <mat-select 
                class="task-form-select body-l-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-board" 	
                [placeholder]="'Строк на одной странице'" formControlName="page_rows_qty">
                <mat-select-trigger>
                    {{'Строк на странице:  '}}{{ page_rows_qty?.value}} 
                </mat-select-trigger>
                @for (opt of  ['10','25','50','100'];  track opt) {
                    <mat-option 
                    class="body-l-regular text-extra task-form-select-option " [value]="opt"> <div>{{opt}}</div> </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field-cs" floatLabel="always" style="margin-right:12px !important; width:300px">
            <mat-select 
                class="task-form-select body-l-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-board" 	
                [placeholder]="'Предзагрузка кол-во строк'" formControlName="rows_qty_to_cache">
                <mat-select-trigger>
                    {{'Предзагрузка:  '}}{{ rows_qty_to_cache?.value}} 
                </mat-select-trigger>
                @for (opt of  ['50','150','200','300','400','500','600','800','1000'];  track opt) {
                    <mat-option 
                    class="body-l-regular text-extra task-form-select-option " [value]="opt"> <div>{{opt}}</div> </mat-option>
                }
            </mat-select>
        </mat-form-field>
        @for ( control of this.settingsLabels | keyvalue; track control.key ) {
            <mat-form-field class="form-field-cs" floatLabel="always" style="margin-right:12px !important;">
                <mat-label>{{control.value}}</mat-label>
                <input matInput [formControlName]="control.key" autocomplete="disabled" placeholder="0">
            </mat-form-field>
        }
    </div>
  <div class="settings-button-block">
    <button 
      [disabled]="tableSettings.invalid"
      (click)="saveSettings()"  data-action="saveSettings"
      class="button-icon size-xxl primary-button" type="submit" >
      <mat-icon svgIcon="checkbox-fill"></mat-icon>
      {{('CONFIRM.BUTTONS.CONFIRM'|translate) }}
    </button>
    <button mat-dialog-close class="button-icon size-xxl secondary-button">
      <mat-icon svgIcon="close-line"></mat-icon>
      {{ 'CONFIRM.BUTTONS.CANCEL'|translate }}
    </button>
  </div>
  </form>
